import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Toggle } from "@ts-digital/vrc";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { getDeductibilityGoods } from "../../../../store/actions/precog/assets";

const DeducibilityDrawerFields = ({ editable, setEditable, setModifiedFields, modifiedFields, readOnly = false }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [optionDeductibilityGoods, setOptionDeductibilityGoods] = useState([]);
  
  useEffect(() => {
    
    if (!editable?.accountCode) return; 
    dispatch(getDeductibilityGoods(editable?.accountCode)).then(elem => {
      const arrayDeducibilityGoods = [];
      elem.forEach(element => {
        arrayDeducibilityGoods.push({
          id: element,
          value: element
        });
      });
      
      setOptionDeductibilityGoods(arrayDeducibilityGoods);
      
    }).catch(err => {
      console.log(err);
    });
    
  }, [editable?.accountCode]);
  
  return (
    <div data-testid="DeducibilityDrawerFields" className="pre-cog-assets-drawer-section" style={{flexDirection: "row", justifyContent: "space-between"}}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Toggle
          disabled={readOnly}
          onChange={value => {
            setEditable({ ...editable, isReducedDeductibility: value });
            setModifiedFields({ ...modifiedFields, isReducedDeductibility: value });
          }}
          checked={editable.isReducedDeductibility}
        />
        <div className="precog-withholding-drawer-form—label-text" style={{ marginBottom: 0 }}>
          <FormattedMessage id={"preCog.assetsTab.drawer.isReducedDeductibility"} />
        </div>
      </div>
      <div style={{width: "50%"}}>
        <Select
          data-testid="selectDeducibilityGoods"
          showSearch
          className="pre-cog-assets-drawer-select"
          disabled={readOnly || !editable.isReducedDeductibility}
          style={{ width: "100%" }}
          optionFilterProp="children"
          getPopupContainer={trigger => trigger.parentNode}
          value={editable.reducedDeductibility}
          filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          onSelect={value => {
            setEditable({ ...editable, reducedDeductibility: value });
            setModifiedFields({ ...modifiedFields, reducedDeductibility: value });
          }}
        >
          {optionDeductibilityGoods.map((el, index) => {
            return <Select.Option key={index} value={el.value}>
              {intl.formatMessage({
                id: `preCog.assetsTab.drawer.deductibilityGoods.${el.id}`
              }) 
              }</Select.Option>;
          })}
        </Select>
      </div>
    </div>
  );
};

export default DeducibilityDrawerFields;
